export const messageKeys = [
  'component.merchandising.heading',
  'component.merchandising.subheading',
  'component.merchandising.card.beach.heading',
  'component.merchandising.card.beach.subheading',
  'component.merchandising.card.weekender.heading',
  'component.merchandising.card.weekender.subheading',
  'component.merchandising.card.family.heading',
  'component.merchandising.card.family.subheading',
  'component.merchandising.card.pets.heading',
  'component.merchandising.card.pets.subheading',
  'component.merchandising.card.mountain.heading',
  'component.merchandising.card.mountain.subheading',
  'component.merchandising.card.countryside.heading',
  'component.merchandising.card.countryside.subheading'
];

export const getMessages = ([
  title, subHeading,
  beachTitle, beachSubtitle,
  weekenderTitle, weekenderSubtitle,
  familyTitle, familySubTitle,
  petsTitle, petsSubtitle,
  mountainTitle, mountainSubtitle,
  countrysideTitle, countrysideSubtitle
]) => ({
  title, subHeading,
  beach: {
    title: beachTitle,
    subtitle: beachSubtitle
  },
  weekender: {
    title: weekenderTitle,
    subtitle: weekenderSubtitle
  },
  family: {
    title: familyTitle,
    subtitle: familySubTitle
  },
  pets: {
    title: petsTitle,
    subtitle: petsSubtitle
  },
  mountain: {
    title: mountainTitle,
    subtitle: mountainSubtitle
  },
  countryside: {
    title: countrysideTitle,
    subtitle: countrysideSubtitle
  }
});
